// Monitorizare erori self-hosted (fără terți): prinde erorile JS din browser și
// le trimite la backend, dedublate + throttled, ca adminul să le vadă în panou.
import { API_BASE } from "@/lib/api";

const seen = new Set(); // dedup în sesiune
let sentThisMinute = 0;
setInterval(() => { sentThisMinute = 0; }, 60000);
const MAX_PER_MIN = 6;

function bundleRelease() {
  try {
    const s = [...document.scripts].map((x) => x.src).find((x) => /main\.[a-f0-9]+\.js/.test(x));
    const m = s && s.match(/main\.([a-f0-9]+)\.js/);
    return m ? m[1] : "";
  } catch (e) { return ""; }
}

function report(message, source, lineno, colno, stack) {
  try {
    const msg = String(message || "").slice(0, 500);
    if (!msg) return;
    const low = msg.toLowerCase();
    // Zgomot cunoscut (extensii de browser / cross-origin / ResizeObserver).
    if (low.includes("resizeobserver loop") || msg === "Script error." || low.includes("script error")) return;
    const key = `${msg}|${source || ""}|${lineno || 0}`;
    if (seen.has(key)) return;
    if (sentThisMinute >= MAX_PER_MIN) return;
    seen.add(key);
    sentThisMinute += 1;
    const body = JSON.stringify({
      message: msg,
      source: String(source || "").slice(0, 300),
      lineno: lineno || 0,
      colno: colno || 0,
      stack: String(stack || "").slice(0, 2000),
      path: (window.location && window.location.pathname) || "",
      release: bundleRelease(),
    });
    // fetch keepalive: se trimite chiar dacă pagina se închide imediat după eroare.
    fetch(`${API_BASE}/public/client-error`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch (e) { /* nu lăsăm reporter-ul să arunce el însuși */ }
}

export function installErrorReporter() {
  if (typeof window === "undefined" || window.__ct_error_reporter) return;
  window.__ct_error_reporter = true;
  window.addEventListener("error", (e) => {
    if (e && e.error) report(e.message, e.filename, e.lineno, e.colno, e.error.stack);
    else if (e && e.message) report(e.message, e.filename, e.lineno, e.colno, "");
  });
  window.addEventListener("unhandledrejection", (e) => {
    const r = e && e.reason;
    report((r && (r.message || String(r))) || "Unhandled promise rejection", "", 0, 0, r && r.stack);
  });
}
